<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useSkeleton } from '@/modules/core/composables/useSkeleton'
import EntityLayout from '@/modules/investing/components/entities/entity-layout.vue'
import NoteTimeline from '@/modules/investing/components/notes/note-timeline.vue'
import { useNoteStore } from '@/modules/investing/stores/note-store'
import { useEntityStore } from '@/modules/investing/stores/better-entity-store'

const noteStore = useNoteStore()
const entityStore = useEntityStore()

const { entity_id, slug } = useRoute().params as {
  entity_id: string
  slug: string
}

const commentableType = 'investor-sets'

const { skeleton, hideSkeleton, showSkeleton } = useSkeleton()

onMounted(async () => {
  showSkeleton()
  await entityStore.fetchEntity(entity_id, { slug })
  await noteStore.fetchNotes(commentableType, entity_id, { slug })
  hideSkeleton()
})
</script>

<template>
  <EntityLayout selectedTab="notes">
    <div v-if="skeleton" class="py-8 text-center text-sm text-gray-500">Loading...</div>
    <NoteTimeline v-else :commentableType="commentableType" :commentableId="entity_id" permission="admins" />
  </EntityLayout>
</template>
